module.exports = require("../../version/VersionIconNameDisplay.vue");